import {TYPES} from './tasks-action-type.constants';
import {IDS} from './tasks-action-id.constants';
import * as TABS from '../../../common/tabs/tabs.constants';
import {TabsReducer} from '../../../common/tabs/tabs.reducer';
import * as FORM from '../../../common/form/input/input.constants';
import {GridReducer} from '../../../common/grid/grid.reducer';
import {GridFilterReducer} from '../../../common/grid/filter/grid-filter.reducer';
import {getAvailableYearsRange} from '../../../reducers/accreditation.reducer';
import * as GRID from '../../../common/grid/grid.constants';
import get from 'lodash/get';
import set from 'lodash/set';
import merge from 'lodash/merge';
import pick from 'lodash/pick';
import moment from 'moment'
import {getDocFileNameFromPath} from "../../../common/utils/util.path";

/**
 * @function TasksReducer
 * @param state {object}
 * @param action {object}
 * @returns {object} Redux Store
 * @memberOf Reducers
 */
export function TasksReducer(state, action) {
    const currentYear = new Date().getFullYear();
    if (typeof state === 'undefined') {
        const currentYear = parseInt(moment().format('YYYY'))
        return {
            // siteLocationUuid: null,
            // siteLocationName: null,
            // fiscalYearStart: null,
            // sloQualityManagers: null,
            // reviewStatuses: [],

            taskDetails:{},
            improvementAction:{},

            [IDS.accTasksGrid]: {
                ...GridReducer(),
                filter: {
                    ...GridFilterReducer(),
                    task_type: 'utrcer,utrcdr',
                    task_status: 'isall',
                    scheme_code: null,
                    keyword: null,
                    my_tasks_only: 1,
                    assignee_uuid: null,
                    year_start: null,
                    year_end: null,
                }
            },
            [IDS.rcoEvidenceGroupDocumentsGrid]: {
                ...GridReducer(),
                filter: { limit: null },
            },
            taskTypes:  [
                {type:'utrcom', value: 'utrcom'},
                {type:'utrcau', value: 'utrcau'},
                {type:'utrcer', value: 'utrcer,utrcdr'},
                {type:'utimas', value: 'utimas'},
            ],
            taskStatuses: [
                {value: 'isopen'},
                {value: 'isall'},
                // {value: 'wai'},
                // {value: 'pen'},
                // {value: 'upl'},
                // {value: 'cpl'},
            ],
            taskSchemes: [],
            // documentTypes: [
            //     { value: 'gdo', label: 'Generic Doc.' },
            //     { value: 'pol', label: 'Policy' },
            //     { value: 'pro', label: 'Procedure' },
            //     { value: 'coa', label: 'Contracts/Agreements' },
            //     { value: 'for', label: 'Form' },
            //     { value: 'che', label: 'Checklist' },
            // ],
        }
    }

    switch (action.type) {
        case TYPES.FETCH_SCHEMES:
            if (action.id === IDS.accTasksGrid) {
                return set({...state}, 'taskSchemes', action.items)
            }
            return state;
        case TYPES.LOCALIZE_TASKS_GRID_FILTER:
            if (action.id === IDS.accTasksGrid) {
                state = set({...state}, 'taskStatuses', action.taskStatuses)
                return set(state, 'taskTypes', action.taskTypes)
            }
            return state;
        case TYPES.TASK_DETAILS_REFRESH:
            if (action.id === IDS.accTasks) {
                const doc_type = action.data.doc_type_code;
                return set({...state}, 'taskDetails', {
                    ...action.data,
                    doc_type: doc_type || action.firstDocType,
                    comment: action.data.status_code === 'sub' ? action.data.closing_comment : null,
                    includedRequirements: action.data.requirements?.filter(requirement => requirement.required),
                    notIncludedRequirements: action.data.requirements?.filter(requirement => !requirement.required),
                })
            }
            return state;
        case TYPES.IMPROVEMENT_ACTION_REFRESH:
            if (action.id === IDS.accTasks) {
                return set({...state}, 'improvementAction', action.data)
            }
            return state;
        case TYPES.SAVE_UPLOADED_DOCUMENT:
            if (action.id === IDS.accSection) {
                state = set({...state}, 'taskDetails.filename', getDocFileNameFromPath(action.filePath));
                set(state, 'taskDetails.doc_id', action.doc_id);
                return set(state, 'taskDetails.doc_url', action.filePath);
            }
        // case TYPES.FETCH_SITE_LOCATION_DETAILS:
        //     if (action.id === IDS.accTasks) {
        //         return { ...state, ...action.data }
        //     }
        // case TYPES.FETCH_DOCUMENT_DETAILS:
        //     if (action.id === IDS.accTasks) {
        //         return {...state,
        //             documentDetails: action.details,
        //             documentReviewsGrid: {
        //                 ...state.documentReviewsGrid,
        //                 items: action.reviews,
        //                 itemsCount: action.reviews.length
        //             }
        //         }
        //     }
        //
        // case TYPES.INIT_REVIEW_STATUSES:
        //     if(action.id === IDS.accTasks) {
        //         return {...state, reviewStatuses: action.reviewStatuses };
        //     }

        /* GENERIC TYPES */

        // case 'LOCATION_SELECTED':
        //     if(action.id === IDS.accTasks) { // slo select-cascade
        //         if(action.type_code === 'slo') {
        //             return {...state, siteLocationUuid: action.uuid}
        //         }
        //         else return state;
        //     }
        // case 'AUTOCOMPLETE_SELECTED':
        //     if (action.id === IDS.accTasks && action.item) {
        //         return set({...state}, action.path, action.item)
        //     }
        case FORM.INPUT_SELECT:
            if (action.id === IDS.accTasks) {
                const [gridName, filterProp, property] = action.path.split('.');
                if ([
                    IDS.accTasksGrid,
                ].includes(gridName) && filterProp === 'filter') {
                    const filter = {
                        [property]: action.input
                    };
                    return set({...state}, gridName,
                        GridReducer(get(state, gridName), {type: GRID.GRID_FILTER, filter})
                    )
                }
                else {
                    return set({...state}, action.path, action.input)
                }
            }
            return state;
        case FORM.INPUT_TEXT:
        case FORM.INPUT_CHECKBOX:
        case FORM.INPUT_DATE:
        case FORM.INPUT_RADIO:
        case 'INPUT_EMAIL_CHANGE':
        case 'INPUT_PHONE_CHANGE':
        case 'INPUT_TEXT_AREA_CHANGE':
        case 'INPUT_SIGNATURE':
            if (action.id === IDS.accTasks) { //selectedYear
                const gridId = action.path.split('.')[0];
                if([IDS.accTasksGrid].includes(gridId)) {
                    const filter = {
                        [action.path.split('.').pop()]: action.input
                    };
                    return set({...state}, gridId,
                        GridReducer(get(state, gridId), { type: GRID.GRID_FILTER, filter })
                    )
                }
                else {
                    const path = action.path
                        + (action.index !== undefined ? `[${action.index}]` : '')
                        + (action.prop ? `.${action.prop}` : '')
                    return set({...state}, path, action.input)
                }
            }
        case GRID.GRID_INIT:
        case GRID.GRID_FILTER:
        case GRID.GRID_FILTER_TOGGLE:
        case GRID.GRID_RESET_FILTER:
        case GRID.GRID_INIT_FILTER:
        case GRID.GRID_LOADING:
        case GRID.GRID_PAGINATE:
        case GRID.GRID_RELOAD:
        case GRID.GRID_FETCH:
        case GRID.GRID_SELECT:
        case GRID.GRID_SELECT_ALL:
        case GRID.GRID_DESELECT:
        case GRID.GRID_DESELECT_ALL:
            if(action.id === IDS.accTasks) {
                return set({...state}, action.path, GridReducer(get(state, action.path), action));
            }
        case GRID.GRID_RESET:
            if (action.id === IDS.accTasks) {
                state = set({...state}, action.path,
                    GridReducer( state[action.path],{
                        type: GRID.GRID_RESET_FILTER,
                        exclude: ['user_uuid','assignee_uuid','year_start','year_end','my_tasks_only','isAdmin']
                    })
                );
                merge(state[action.path], {
                    // set "reset" flag to trigger slo SELECT_CASCADE_RESET in grid filter
                    reset: !state[action.path].reset,
                    reload: state[action.path].filter.page === 1 ? !state[action.path].reload : state[action.path].reload,
                    // set default values
                    filter: {
                        task_type: 'utrcom',
                        task_status: 'isopen',
                        my_tasks_only: state[action.path].filter.isAdmin ? 0 : 1,
                    }
                });
                return state;
            }

        case 'LOCATION_SELECTED':
            if (action.id === IDS.accTasks && [IDS.accTasksGrid].includes(action.path)) { // slo select-cascade
                if(action.type_code === 'slo') {
                    state = set({...state}, action.path, GridReducer(state[action.path], set(action, 'type', 'PAGINATE')));
                    return set(state, `${action.path}.filter.slo_uuid`, action.uuid);
                }
                return state;
            }
        default:
            return state;
    }
}

const index = (children, list = []) => {
    children && children.forEach(item => {
        if(item) {
            list[parseInt(item.id)] = item;
            index(item.children, list);
        }
    })
    return list;
};
